var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKucoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113_2096)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_113_2096)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_113_2096)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_113_2096",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4483 0.551758H0.551758V31.4483H31.4483V0.551758Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_113_2096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8447 15.9998C10.8447 13.163 13.1597 10.8481 15.9964 10.8481C18.833 10.8481 21.1479 13.163 21.1479 15.9998C21.1479 18.8364 18.833 21.1514 15.9964 21.1514C13.1597 21.1514 10.8447 18.8364 10.8447 15.9998Z",
    fill: "#E4007F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4478 15.2197C31.4474 15.4795 31.4472 15.7396 31.4472 16C31.4472 16.2912 31.4476 16.582 31.448 16.8725C31.4507 18.7107 31.4535 20.538 31.3467 22.3768C31.2268 24.8501 30.6665 27.0415 28.854 28.854C27.0453 30.6627 24.8501 31.2268 22.3768 31.3467C20.5072 31.4518 18.6496 31.4499 16.7804 31.4478C16.5205 31.4474 16.2604 31.4472 16 31.4472C15.7402 31.4472 15.4805 31.4474 15.2211 31.4478C13.3544 31.4499 11.4963 31.4518 9.62332 31.3467C7.14991 31.2268 4.95864 30.6665 3.14611 28.854C1.33744 27.0453 0.773195 24.8501 0.653389 22.3768C0.548202 20.5072 0.550263 18.6464 0.552332 16.779C0.55262 16.5195 0.552908 16.2599 0.552908 16C0.552908 15.7402 0.55262 15.4805 0.552332 15.2211C0.550263 13.3544 0.548204 11.4963 0.653389 9.62332C0.773195 7.14991 1.33357 4.95864 3.14611 3.14611C4.95478 1.33744 7.14991 0.773195 9.62332 0.653389C11.4929 0.548207 13.3504 0.550263 15.2197 0.552332C15.4795 0.552619 15.7396 0.552907 16 0.552907C16.2599 0.552907 16.5195 0.55262 16.779 0.552332C18.6457 0.550263 20.5038 0.548204 22.3768 0.653389C24.8501 0.773195 27.0415 1.33357 28.854 3.14611C30.6627 4.95478 31.2268 7.14991 31.3467 9.62332C31.4518 11.4928 31.4499 13.3504 31.4478 15.2197ZM8.06971 16C8.06971 20.3865 11.6097 23.9265 15.9962 23.9265C20.3826 23.9265 23.9227 20.3865 23.9227 16C23.9227 11.6136 20.3826 8.07358 15.9962 8.07358C11.6097 8.07358 8.06971 11.6136 8.06971 16ZM22.3961 7.74894C22.3961 8.77308 23.2231 9.60012 24.2473 9.60012C25.2714 9.60012 26.0946 8.77695 26.0985 7.74894C26.0985 6.7248 25.2714 5.89776 24.2473 5.89776C23.2231 5.89776 22.3961 6.7248 22.3961 7.74894Z",
    fill: "#E4007F"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113_2096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_113_2096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_113_2096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 30.8966,
    fill: "white",
    transform: "translate(0 0.551758)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKucoin);
export default __webpack_public_path__ + "static/media/kucoin.f2171eff9fc4fb79a8ddbef6cd6233f8.svg";
export { ForwardRef as ReactComponent };